// app/helpers/interactions/handlersKeyDown.js

export function makeHandleKeyDown(ctx) {
  return function handleKeyDown(event) {
    if (event.key === "Delete") {
      if (ctx.selectedMeasurement && ctx.selectedMeasurement !== "scale") {
        ctx.setMeasurements((prev) =>
          prev.filter((m) => m.id !== ctx.selectedMeasurement)
        );
        ctx.setSelectedMeasurement(null);
        ctx.addToHistory();
      } else if (ctx.selectedText) {
        ctx.setTextAnnotations((prev) =>
          prev.filter((t) => t.id !== ctx.selectedText)
        );
        ctx.setSelectedText(null);
        ctx.addToHistory();
      } else if (ctx.selectedGuideline) {
        ctx.setGuidelines((prev) =>
          prev.filter((g) => g.id !== ctx.selectedGuideline)
        );
        ctx.setSelectedGuideline(null);
        ctx.addToHistory();
      } else if (ctx.selectedPolygon) {
        ctx.setPolygons((prev) =>
          prev.filter((p) => p.id !== ctx.selectedPolygon)
        );
        ctx.setSelectedPolygon(null);
        ctx.addToHistory();
      }
    }
    if (event.key === "Enter" && ctx.selectedText) {
      ctx.setTextAnnotations((prev) =>
        prev.map((a) =>
          a.id === ctx.selectedText ? { ...a, isEditing: true } : a
        )
      );
    }
    if (
      event.key === "Escape" &&
      ctx.activeTool === "polygon" &&
      ctx.currentPoints.length > 0
    ) {
      ctx.setCurrentPoints([]);
    }
  };
}
